const Class3 = () => {
    return (
        <section className="lg:my-8">
            <div className="px-3 sm:px-4 lg:px-16 pt-8 lg:pb-2 bg-beige/60 mx-3 md:mx-8 lg:mx-20 rounded-lg shadow-lg ">
                <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold mb-10 font-heading">
                    Bas-Relief Workshop
                </h1>
                <div className="w-full flex max-md:flex-col">
                    {/* Portrait */}
                    <div className="mr-5 flex-1 max-md:mx-auto">
                        <img
                            src="/images/class/bas-relief-detail.jpg"
                            alt="Artist Portrait"
                            className="rounded-lg shadow-lg mx-auto lg:mx-0 object-cover w-full"
                        />
                    </div>
                    {/* Text */}
                    <div className="text-brown-700 lg:text-lg text-base lg:leading-relaxed leading-5 text-justify flex-[2] max-md:flex-1 font-para font-semibold">
                        <p className="lg:mb-6 md:mb-5 mb-4 mt-4">
                            Sculpt and paint a beautiful bas relief kingfisher, over two sessions, with experienced
                            artist Sandhya Mulchandani. Suitable for all skill levels, this workshop blends a rich ancient Indian artform with an Australian image and modern techniques and bring Kingfisher’s Haven to life this SALA Festival! This workshop is a part of SALA Festival exhibition held at Duthy street art supply from 27th August to 7th September, 10am to 4pm daily
                        </p>
                        <p className="mb-2">
                            Workshop Schedule:
                        </p>
                        <p className="mb-2 ms-2">
                            Evening 1 - Sculpting (27 August 2025): 4-6pm
                            Begin your bas relief journey by shaping the intricate forms of a kingfisher and surrounding blooms. Learn how to create depth, texture, and balance using hands-on sculpting techniques.
                        </p>
                        <p className="mb-4 ms-2">
                            Evening 2 - Painting (3 September 2025): 4-6pm
                            Paint your now dry sculpture. Explore bold colour palettes and finishing techniques under expert guidance to bring your scene to life.

                        </p>
                        <p className="mb-4">
                            Dates: Wednesday, 27 August & 3 September 2025<br />
                            Time: 4:00 PM - 6:00 PM (Please arrive by 3:30 PM)<br />
                            Dates: Wednesday, 27 August & 3 September 2025<br />
                            Time: 4:00 PM - 6:00 PM (Please arrive by 3:30 PM)<br />
                            Price: $110 for combined sessions. Total price.<br />
                            Venue: Duthy street Art Supply - 6 Duthy St, Unley South Australia 5061<br />
                            Price: $110 for combined sessions (materials included)<br /><br />
                            Click <a href="https://events.humanitix.com/timeless-art-of-bas-relief-kingfisher-s-haven-a-two-day-workshop" className="text-blue-500 underline" target="_blank">HERE</a> to book or scan the QR code!
                        </p>
                        <div className="flex justify-center mt-8">
                            <button className="text-brown-700 text-xl sm:text-2xl font-semibold shadow-inset w-[45%] max-sm:w-[50%] transition-all rounded-lg py-2 hover:shadow-xl hover:bg-beige">
                                <a href="/#contactNav">Equire Now</a>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="w-full flex justify-center my-8">

                </div>
            </div>
            {/* <iframe width={window.innerWidth <= 800? '320px': '650px'} height={window.innerWidth <= 1000? '181px': '370px'} className="my-5 mx-auto rounded-sm"
                src="https://www.youtube.com/embed/qqGZG5CLE9s?playlist=qqGZG5CLE9s&autoplay=1&mute=1&loop=1">
            </iframe> */}
            {/* <video>
                <source src="/images/class/bas-vid.mp4" type="video/mp4" />
            </video> */}
            {/* <div className="flex justify-center my-5">
                <iframe  className="aspect-4/3 rounded-sm "
                    src="https://www.youtube.com/embed/qqGZG5CLE9s?playlist=qqGZG5CLE9s&autoplay=1&mute=1&loop=1">
                </iframe>
            </div> */}
            <iframe  className="aspect-video lg:max-w-[60%] md:max-w-[70%] max-w-[85%] mx-auto my-5 rounded-md"
                    src="https://www.youtube.com/embed/qqGZG5CLE9s?playlist=qqGZG5CLE9s&autoplay=1&mute=1&loop=1">
                </iframe>
        </section>
    );
};

export default Class3;